import React from 'react';
import { Modal } from 'react-bootstrap';

import SVButton from './SVButton';

export interface BasicModalProps {
  title?: string;
  body?: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onCloseTxt?: string;
  onConfirm?: () => void;
  onConfirmTxt?: string;
  size?: 'sm' | 'lg' | 'xl';
  disableConfirm?: boolean;
}

const BasicModal: React.FC<BasicModalProps> = ({
  title,
  body,
  isOpen,
  onClose,
  onCloseTxt = 'No',
  onConfirm,
  onConfirmTxt = 'Yes',
  size = 'lg',
  disableConfirm = false,
}) => (
  <Modal show={isOpen} onHide={onClose} size={size} centered>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    {body && <Modal.Body>{body}</Modal.Body>}
    <Modal.Footer>
      <SVButton variant="cancel" onClick={onClose}>
        {onCloseTxt}
      </SVButton>
      {onConfirm && (
        <SVButton onClick={onConfirm} disabled={disableConfirm}>
          {onConfirmTxt}
        </SVButton>
      )}
    </Modal.Footer>
  </Modal>
);

export default BasicModal;
